import React, { useEffect ,useState} from "react";
import style from "./index.module.scss";
import "./banner.scss";
import Swiper from "swiper";
import "swiper/css/swiper.css";
import { showDialog } from "./dialog";
import { Link, useHistory } from "react-router-dom";
import {queryIndexBool} from "utils/api";

const App = () => {
  const history = useHistory();
  let swiperDom = null
  const deleteImg = (e) => {
    let dom = e.target.nextElementSibling || e.target.nextSibling;
    dom.parentNode.removeChild(dom);
  };
  const [flag, setFlag] = useState(false);
  const goto = (path) => {
    window.scrollTo(0, 0);
    history.push(path);
  }
  useEffect(() => {
    window.onload = () => {
      let image = new Image();
      image.src = "";
      image.onload = () => {};
    };
    queryIndexBool().then((res)=>{
        // console.log(res)
        if(res.data&&res.data.success){
          setFlag(res.data.result)
          //setFlag(true)
        }
        swiperDom = new Swiper(".swiper-container", {
          loop: true,
          autoplay: {
            delay:3000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          on:{
            click:function(e){
              console.log('点击了 swiper')
              const dom = e.target
              if(dom.getAttribute('class') == 'hezuo'){
                
                showDialog()
                swiperDom.init()
              }
              
            }
          }
        });
    })
  
  }, []);

  const dialog = ()=>{
    console.log('点击')
  }
  return (
    <div className={style.bannerContainer}>
      <div className="swiper-container">
        <div className="swiper-wrapper">
          <div className="swiper-slide">
            <img
              src={`https://img10.360buyimg.com/imagetools/jfs/t1/152071/39/1896/2222572/5f8163bdE38ca6281/838f07a5bc89c511.png!cc_${window.innerWidth}x600`}
              alt=""
              onLoad={(e) => {
                deleteImg(e);
              }}
            />
            <img
              src={`https://img10.360buyimg.com/imagetools/jfs/t1/144759/28/12171/214228/5f98cfdcEb4206790/0c2d0c0b5f6de7ef.jpg!q30!cc_${window.innerWidth}x600`}
              alt=""
            />
            <div className="center">
              <h1>API对接采购供应链解决方案</h1>
              <div className="subtitle">
                提高通用物资集采率及采购效率。解决管理多个供应商的合规风控问题，让采购规范透明，降低人力成本，采购价格统一
              </div>
              <div className="hezuo" clstag="pageclick|keycount|VopOpenIndex_1602911919488|5">我要合作 </div>
            </div>
          </div> 
          <div className="swiper-slide">
            <img
              src={`https://img11.360buyimg.com/imagetools/jfs/t1/116187/33/19805/2200198/5f8163beEdc5492d6/71408b6de18ad1e7.png!cc_${window.innerWidth}x600`}
              alt=""
              onLoad={(e) => {
                deleteImg(e);
              }}
            />
            <img
              src={`https://img13.360buyimg.com/imagetools/jfs/t1/148393/25/12345/139088/5f98cf01Ef76cdbb4/106d40fc5d82ceb9.jpg!q30!cc_${window.innerWidth}x600`}
              alt=""
            />
            <div className="center">
              <h1>多场景全覆盖接入型解决方案</h1>
              <div className="subtitle">
                提供内部采购延伸多场景的接入型解决方案：办公集采、员工福利、市场活动、虚拟业务、渠道奖励
              </div>
              <div className="hezuo" clstag="pageclick|keycount|VopOpenIndex_1602911919488|5">我要合作</div>
            </div>
          </div>
          <div className="swiper-slide">
            <img
              src={`https://img10.360buyimg.com/imagetools/jfs/t1/148379/26/10306/2195886/5f8163c0E9dac57b4/7bc303015b2816e7.png!cc_${window.innerWidth}x600`}
              alt=""
              onLoad={(e) => {
                deleteImg(e);
              }}
            />
            <img
              src={`https://img13.360buyimg.com/imagetools/jfs/t1/141323/28/12283/143795/5f98cf00Ea498f479/9ab8095ce6c33599.jpg!q30!cc_${window.innerWidth}x600`}
              alt=""
            />
            <div className="center">
              <h1>多行业全覆盖接入型解决方案</h1>
              <div className="subtitle">
                金融保险、制造、大交通、运营商、能源、互联网、建筑地产等全行业覆盖提供对应解决方案
              </div>
              <div className="hezuo" clstag="pageclick|keycount|VopOpenIndex_1602911919488|5">我要合作</div>
            </div>
          </div>
          <div className="swiper-slide">
            <img
              src={`https://img10.360buyimg.com/imagetools/jfs/t1/104917/38/29860/1042604/6283092cEd04ff0f4/44f498bbac343106.png!cc_${window.innerWidth}x600`}
              alt=""
              onLoad={(e) => {
                deleteImg(e);
              }}
            />
            <img
              src={`https://img10.360buyimg.com/imagetools/jfs/t1/104917/38/29860/1042604/6283092cEd04ff0f4/44f498bbac343106.png!q30!cc_${window.innerWidth}x600`}
              alt=""
            />
            <div className="center">
              <h1>组件化采购解决方案</h1>
              <div className="subtitle">
              通过嵌入模块化的组件服务，可以降低客户开发成本和复杂度，加速客户采购商城的搭建速度，实现一次性接入，迭代无忧。
              </div>
              <div className="hezuo" clstag="pageclick|keycount|VopOpenIndex_1602911919488|5">我要合作</div>
            </div>
          </div>
          {
            flag?  <div className="swiper-slide">
            <img
              src={`https://img11.360buyimg.com/imagetools/jfs/t1/153478/26/3962/17712/5f9a881aEdf5c638f/b4436e7d58f18d7c.png!cc_${window.innerWidth}x600`}
              alt=""
              onLoad={(e) => {
                deleteImg(e);
              }}
            />
            <img
              src={`https://img11.360buyimg.com/imagetools/jfs/t1/153478/26/3962/17712/5f9a881aEdf5c638f/b4436e7d58f18d7c.png!q30!cc_${window.innerWidth}x600`}
              alt=""
            />
            <div className="center">
              <h1>白皮书入口</h1>
              <div className="subtitle">
                白皮书入口测试出
              </div>
              <div className="hezuo">
                <span
          onClick={() => goto("/paper")}
          clstag="pageclick|keycount|VopOpenIndex_1602911919488|5"
        >
          查看白皮书
        </span></div>
            </div>
          </div>:null
          }
        
        </div>
        <div className="swiper-pagination"></div>
        <div className="swiper-btn">
          <div className="swiper-button-prev"></div>
          <div className="swiper-button-next"></div>
        </div>
      </div>
      {/* <div className={`${style.coop}`}>
          <span
          onClick={() => showDialog()}
          clstag="pageclick|keycount|VopOpenIndex_1602911919488|5"
        >
          我要合作
        </span>
      </div> */}
    </div>
  );
};

export default App;
